import { render, staticRenderFns } from "./CreditsDetail.vue?vue&type=template&id=220ff096&scoped=true"
import script from "./credits_detail.js?vue&type=script&lang=js&external"
export * from "./credits_detail.js?vue&type=script&lang=js&external"
import style0 from "./credits_detail.scss?vue&type=style&index=0&id=220ff096&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ff096",
  null
  
)

export default component.exports